/**
 * ESM re-export shim for the byte-identical UMD `roles.js`.
 *
 * `roles.js` uses no import/export (so the SAME file loads as a window <script>
 * on desktop and via CJS require in the main process). Frontend code wants clean
 * named imports, so this thin module imports it for its side-effect (which
 * populates globalThis.InquisitorRoles) and re-exports the surface.
 */
import './roles.js';

const R = globalThis.InquisitorRoles;

export const ROLES = R.ROLES;
export const DEFAULT_ROLE = R.DEFAULT_ROLE;
export const PUNISH_FEATURES = R.PUNISH_FEATURES;
export const COMMS_FEATURES = R.COMMS_FEATURES;
export const isValidRole = R.isValidRole;
export const normalizeRole = R.normalizeRole;
export const getRole = R.getRole;
export const listRoles = R.listRoles;
export const roleAllowsFeature = R.roleAllowsFeature;

export default R;
